import React from "react";
import {
  formatDistanceToNow,
  parseISO,
  isFuture,
  formatISO,
  addDays,
} from "date-fns";

import Tabs from "./Tabs";
import WriteTab from "./WriteTab";
import RecordTab from "./RecordTab";
import PublishTab from "./PublishTab";

const Episode = ({ episode, onChange, uid }) => {
  const { date, stage } = episode;

  return (
    <div className="rounded overflow-hidden shadow-lg bg-gray-200 my-6 relative w-full">
      <input
        type="date"
        className="font-bold text-xl mx-6 mt-4 bg-gray-200"
        value={date}
        onChange={(e) => onChange({ ...episode, date: e.target.value })}
      />
      <p className="mx-6 mb-2 text-gray-500">
        {formatDistanceToNow(parseISO(date))}{" "}
        {isFuture(parseISO(date)) ? "from now" : "ago"}
      </p>

      {stage !== "archived" && (
        <React.Fragment>
          <Tabs
            activeTabId={stage}
            setActiveTabId={(activeTabId) =>
              onChange({ ...episode, stage: activeTabId })
            }
          />
          <div className="px-6 py-4 bg-white">
            {stage === "write" && (
              <WriteTab episode={episode} setEpisode={onChange} />
            )}
            {stage === "record" && (
              <RecordTab episode={episode} setEpisode={onChange} uid={uid} />
            )}
            {stage === "publish" && (
              <PublishTab episode={episode} setEpisode={onChange} />
            )}
          </div>
        </React.Fragment>
      )}
      <button
        className={`${
          stage === "archived"
            ? "bg-gray-300 hover:bg-gray-400"
            : "bg-blue-500 hover:bg-blue-700 text-white"
        } w-full font-bold py-2 px-4 rounded-b`}
        onClick={() => {
          let nextStageId = "write";
          if (stage === "write") nextStageId = "record";
          else if (stage === "record") nextStageId = "publish";
          else if (stage === "publish") nextStageId = "archived";
          else if (stage === "archived") nextStageId = "publish";

          onChange({ ...episode, stage: nextStageId });
        }}
      >
        {stage === "write"
          ? "🎙 Record"
          : stage === "record"
          ? "🚀 Publish"
          : stage === "publish"
          ? "🗄 Archive"
          : "⛏ Un-archive"}
      </button>
    </div>
  );
};

export default Episode;
